<template>
  <div>
    <div class="row mb-5">
      <div class="col">
        <div class="card card-bg-light card-bordered shadow-lg card-hover-shadow">
          <div class="card-header">
            <h4 class="card-title"><i class="fas fa-sliders-h"></i> Filter your results...</h4>
            <div class="right-0 top-0">
              <button class="btn btn-xs btn-soft-secondary mr-2" @click="closeFilters()">Close</button>
              <button class="btn btn-xs btn-primary" @click="applyFilters()">Apply</button>
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent>
              <div class="row">
                <div v-if="ltvMaxOptions != null && ltvMaxOptions.length > 0" class="col-4">
                  <InlineRadioOptions v-model="filters.ltv" title="Loan-to-Value" name="ltvMax"
                                      :options="ltvMaxOptions"
                                      :modified="values.ltv !== filters.ltv"
                                      @reset="filters.ltv = values.ltv" 
                                      @clear="filters.ltv = null"/>
                </div>
                <div v-if="initialPeriodOptions != null && initialPeriodOptions.length > 0" class="col-4">
                  <InlineRadioOptions v-model="filters.initialPeriodDuration" title="Initial Period (years)" name="initialPeriodDuration"
                                      :options="initialPeriodOptions" :inline="true"
                                      :modified="values.initialPeriodDuration !== filters.initialPeriodDuration" 
                                      @reset="filters.initialPeriodDuration = values.initialPeriodDuration" 
                                      @clear="filters.initialPeriodDuration = null"/>
                </div>
<!--                <div class="col-4">-->
<!--                  <InlineRadioOptions v-model="filters.initialPeriod" title="Initial Period" name="initialPeriod"-->
<!--                                      :options="options.initialPeriod"-->
<!--                                      :modified="values.initialPeriod !== filters.initialPeriod"-->
<!--                                      @reset="filters.initialPeriod = values.initialPeriod"/>-->
<!--                </div>-->
                <div class="col-4">
                  <InlineCheckboxOptions v-bind:values="filters.lenderFeatures" title="Lender Features" name="lenderFeatures"
                                         :inline="false"
                                         :options="options.lenderFeatures"
                                         @updated="filters.lenderFeatures = $event"
                                         :modified="JSON.stringify(values.lenderFeatures) !== JSON.stringify(filters.lenderFeatures)" 
                                         @reset="filters.lenderFeatures = values.lenderFeatures" 
                                         @clear="filters.lenderFeatures = []"/>
                </div>
                <div class="col-4">
                  <label class="input-label">Your current lender</label>
                  <multiselect v-model="filters.lender" :options="lenderOptions" placeholder="Select lender..."
                               :searchable="true" label="label" track-by="value">
                  </multiselect>
                </div>
                <div class="col-12">
                  <InlineCheckboxOptions v-bind:values="filters.advancedFeatures" title="Advanced Features" name="advancedFeatures"
                                         :inline="true"
                                         :options="options.advancedFeatures"
                                         @updated="filters.advancedFeatures = $event"
                                         :modified="JSON.stringify(values.advancedFeatures) !== JSON.stringify(filters.advancedFeatures)" 
                                         @reset="filters.advancedFeatures = values.advancedFeatures" 
                                         @clear="filters.advancedFeatures = []"/>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import InlineRadioOptions from "@/components/products/InlineRadioOptions";
import InlineCheckboxOptions from "@/components/products/InlineCheckboxOptions";
import formDefaults from "@/config/searchFormDefaults.json"

export default {
  name: "ProductFilters",
  
  components: {
    InlineRadioOptions,
    InlineCheckboxOptions,
    Multiselect
  },
  
  data() {
    return {
      options: {},
      filters: {
        initialPeriodDuration: null,
        excludeFees: null,
        initialPeriod: null,
        ltv: null,
        lenderFeatures: [],
        advancedFeatures: [],
        lender: null
      }
    }
  },
  
  created() {
    this.options = { ...formDefaults.filter.options };
  },
  
  mounted() {
    this.filters = { ...this.values };
  },

  props: {
    values: Object,
    facets: Object
  },

  computed: {
    lenderOptions() {
      if (this.facets["lender"] == null) return {};
      return [ ...this.facets["lender"] ]
          .sort(function (a, b) {
            return a.key - b.key;
          })
          .map(f => {
            return {
              label: f.key + " (" + f.value + ")",
              count: f.value,
              value: f.key
            };
          });
    },

    initialPeriodOptions() {
      if (this.facets["initialPeriodDuration"] == null) return {};
      return [ ...this.facets["initialPeriodDuration"] ]
          .sort(function (a, b) {
            return a.key - b.key;
          })
          .map(f => {
            return {
              label: (f.key / 12) + " yrs",
              count: f.value,
              value: f.key,
              tooltip: (f.key / 12) + " yrs (" + f.value + " results)"
            };
          });
    },

    ltvMaxOptions() {
      if (this.facets["ltvMaxPercent"] == null) return {};
      return [ ...this.facets["ltvMaxPercent"] ]
          .sort(function (a, b) {
            return a.key - b.key;
          })
          .map(f => {
            return {
              label: f.key + "%",
              count: f.value,
              value: f.key
            };
          });
    },

    filterValues() {
      return {
        // "initialPeriodDuration": this.filters.initialPeriodDuration,
        "ltv": this.filters.ltv,
        "features": this.filters.features,
        "lenderFeatures": this.filters.lenderFeatures,
        "advancedFeatures": this.filters.advancedFeatures,
        "initialPeriod": this.filters.initialPeriod,
        "lender": this.filters.lender == null ? null : this.filters.lender.value
      }
    }
  },

  methods: {
    closeFilters() {
      this.$emit("closed");
    },
    
    applyFilters() {
      this.$emit("apply", this.filterValues);
    }
  }
}
</script>
